module.exports = __webpack_public_path__ + "static/media/notificacao.59cde4f3.jpg";